import { render, staticRenderFns } from "./DrawingBoard.vue?vue&type=template&id=7ededa68&"
import script from "./DrawingBoard.vue?vue&type=script&lang=js&"
export * from "./DrawingBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports